import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  linkSupportStart: ({ spacing }) => css`
    display: flex;
    justify-content: center;
    margin-top: ${spacing.md};
  `,
  buttonLogin: ({ spacing }) => css`
    margin-top: ${spacing.xxs};
  `,
  title: ({ spacing }) => css`
    margin-top: ${spacing.sm};
    margin-bottom: ${spacing.xs};
  `,
  subtitle: ({ colors, spacing }) => css`
    color: ${colors.neutral[200]};
    margin-bottom: ${spacing.md};
  `,
  startForm: ({ spacing, colors }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: ${spacing['2xl']};
    margin: auto;
    @media screen and (max-width: 768px) {
      margin-top: ${spacing.xl};
    }
    h1 {
      margin-bottom: ${spacing.xxs};
    }
    h3 {
      margin-bottom: ${spacing.md};
      color: ${colors.neutral[200]};
    }
  `,
  logoWhiteLabel: ({ spacing }) => css`
    width: 10rem;
    margin-bottom: ${spacing.xxs};
  `,
})

export default useStyles
